/* Litborne NOVEMBER26 (truoc 01/11: HALLOWEEN26) — auto-apply + cart drawer hint + collection card price override */
(function() {
  'use strict';
  var CODE = 'NOVEMBER26'; var OLD_CODES = ['HALLOWEEN26']; /* LB-NOV26 v1 (01/11): ma cu trong gio van tinh la sale da ap, toi khi het han 04/11 */
  var DISCOUNT_RATE = 0.5;

  /* Pull just the money substring (symbol + number) out of text like 'Price 3.811.227\u20ab' */
  function extractMoney(text) {
    var m = text.match(/([^\w\s]?)\s*(\d[\d.,]*\d|\d)\s*([^\w\s]?)/);
    if (!m) return null;
    return (m[1] || '') + m[2] + (m[3] || '');
  }

  /* Parse a rendered money string, halve it, re-render in the SAME format.
     Works for $142.99 / £112.87 / 3.811.227\u20ab / 1.234,56 kr ... */
  function makeHalf(text) {
    var m = text.match(/([^\d\s]*)\s*(\d[\d.,\s]*\d|\d)\s*([^\d\s]*)/);
    if (!m) return null;
    var pre = m[1] || '', num = m[2].replace(/\s/g, ''), suf = m[3] || '';
    var dec = 0, decSep = '';
    var lastDot = num.lastIndexOf('.'), lastCom = num.lastIndexOf(',');
    var lastSep = Math.max(lastDot, lastCom);
    if (lastSep > -1) {
      var tail = num.length - lastSep - 1;
      if (tail === 1 || tail === 2) { dec = tail; decSep = num[lastSep]; }
    }
    var digits = num.replace(/[.,]/g, '');
    var minor = parseInt(digits, 10);
    if (isNaN(minor)) return null;
    var half = Math.round(minor / 2);
    var thouSep = '';
    var seps = num.replace(/\d/g, '');
    for (var i = 0; i < seps.length; i++) { if (seps[i] !== decSep || !dec) { thouSep = seps[i]; break; } }
    var s = String(half), frac = '';
    if (dec) {
      while (s.length <= dec) s = '0' + s;
      frac = decSep + s.slice(-dec);
      s = s.slice(0, -dec);
    }
    if (thouSep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return pre + s + frac + suf;
  }



  /* Render an amount (minor units) in the same money format as a sample string */
  function renderLike(sampleText, minor) {
    var m = sampleText.match(/([^\d\s]*)\s*(\d[\d.,\s]*\d|\d)\s*([^\d\s]*)/);
    if (!m) return null;
    var pre = m[1] || '', num = m[2].replace(/\s/g, ''), suf = m[3] || '';
    var dec = 0, decSep = '';
    var lastDot = num.lastIndexOf('.'), lastCom = num.lastIndexOf(',');
    var lastSep = Math.max(lastDot, lastCom);
    if (lastSep > -1) {
      var tail = num.length - lastSep - 1;
      if (tail === 1 || tail === 2) { dec = tail; decSep = num[lastSep]; }
    }
    var thouSep = '';
    var seps = num.replace(/\d/g, '');
    for (var i = 0; i < seps.length; i++) { if (seps[i] !== decSep || !dec) { thouSep = seps[i]; break; } }
    /* cart.js luon tra minor units x100 (ke ca VND/JPY dec=0) -> quy ve don vi hien thi */
    var scaled = Math.round((minor / 100) * Math.pow(10, dec));
    var s = String(scaled), frac = '';
    if (dec) {
      while (s.length <= dec) s = '0' + s;
      frac = decSep + s.slice(-dec);
      s = s.slice(0, -dec);
    }
    if (thouSep) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return pre + s + frac + suf;
  }

  var css = ''
    /* 18/09 (user duyet goi y): (1) td.cart-items__price o goc phai in gia goc KHONG gach ngay tren khoi "$67.93 ~~$142.99~~"
       -> khach tuong do la gia dang tinh; giu DOM (script van doc text de format) nhung an mat. (2) theme in ten ma
       product-class (WELCOME10) vao ul ngay duoi option nhu mot thuoc tinh -> an, chip ben duoi da noi roi. */
    + '.cart-items__table-row[data-key] td.cart-items__price{visibility:hidden;width:0;padding:0!important;font-size:0}'
    + '.cart-items__table-row[data-key] .cart-items__variants-wrapper > ul.list-unstyled{display:none}'
    /* Cart drawer hint */
    + '.lb-s26-saving{display:flex;align-items:center;gap:6px;padding:8px 12px;margin:6px 0 0;'
    + 'font-family:Lora,serif;font-size:12px;color:#c9a55a;background:rgba(201,165,90,.10);'
    + 'border-left:2px solid #c9a55a;letter-spacing:.02em;line-height:1.4}'
    + '.lb-s26-saving strong{color:#e8c97a;font-weight:700}'
    + '.lb-s26-saving svg{flex-shrink:0}'
    + '.lb-s26-saving-row td{padding:0 !important;border:0 !important}'
    + 'td.cart-items__quantity{flex-wrap:wrap}'
    + '.lb-s26-saving--qty{flex-basis:100%;width:auto;max-width:100%;margin:8px 0 0;padding:6px 9px;font-size:10.5px;line-height:1.35;white-space:normal;display:flex;align-items:center;gap:6px}'
    /* Cart unit price block */
    + '.lb-s26-priceblock{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}'
    + '.lb-s26-new{color:#e8c97a;font-weight:700}'
    + '.lb-s26-was{color:rgba(26,26,26,.5);text-decoration:line-through;font-size:.9rem}'
    /* Product card overlay */
    + '.lb-s26-card{display:flex;flex-direction:column;gap:2px;margin-top:4px}'
    + '.lb-s26-card__prices{display:flex;gap:8px;align-items:baseline;flex-wrap:wrap}'
    + '.lb-s26-card__new{color:#e8c97a;font-weight:700;font-size:1rem}'
    + '.lb-s26-card__was{color:rgba(26,26,26,.5);text-decoration:line-through;font-size:.88rem}'
    + '.lb-s26-card__code{font-family:Courier Prime,monospace;font-size:10.5px;letter-spacing:.12em;'
    + 'color:#c9a55a;margin-top:2px;text-transform:none}'
    + '.lb-s26-card__code strong{color:#e8c97a;font-weight:700;letter-spacing:.15em}'
    /* Suggest dropdown: co chu nho lai cho vua card ket qua */
    + '.resource-card .lb-s26-card{margin-top:2px}'
    + '.resource-card .lb-s26-card__new{font-size:.92rem}'
    + '.resource-card .lb-s26-card__was{font-size:.8rem}'
    + '.resource-card .lb-s26-card__code{font-size:9.5px}';
  if (!document.getElementById('lb-s26-style')) {
    var st = document.createElement('style');
    st.id = 'lb-s26-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function getCart() {
    /* Safari caches /cart.js (no Cache-Control header) - always bust + no-store */
    return fetch('/cart.js?_lb=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .catch(function() { return null; });
  }
  function findApp(cart) {
    if (!cart) return null;
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var t = (apps[i].title || apps[i].code || '').toString().toUpperCase();
      if (t === CODE || OLD_CODES.indexOf(t) >= 0) { window.__lbS26Code = t; return apps[i]; }
    }
    return null;
  }
  function getRate(app) {
    if (!app || app.value_type !== 'percentage') return 0;
    return parseFloat(app.value) / 100;
  }
  function userRemoved() {
    try { return sessionStorage.getItem("lb_s26_removed") === "1"; } catch (e) { return false; }
  }
  var autoTries = 0;
  /* auto-apply whenever the code is missing from the cart, unless the shopper
     explicitly removed it this session. Prefers the theme-native discount form
     (pill + totals morph in place, no reload); falls back to the /discount URL
     (cookie) when the cart is empty or the form is unavailable/in use. */
  function tryAutoApply(cart) {
    if (userRemoved() || window.__lbS26Applying || autoTries >= 3) return;
    if (!cart || findApp(cart)) return;
    var comp = document.querySelector("cart-discount-component");
    var input = comp ? comp.querySelector("input") : null;
    var form = input ? input.closest("form") : null;
    var inputBusy = input && document.activeElement === input && input.value !== "";
    if (cart.item_count > 0 && form && input && form.requestSubmit && !inputBusy) {
      autoTries++; /* count only REAL apply attempts - empty-cart ticks must not burn the cap */
      window.__lbS26Applying = true;
      input.value = CODE;
      form.requestSubmit();
      setTimeout(function() { if (input.value === CODE) input.value = ""; window.__lbS26Applying = false; }, 1500);
    }
    /* empty cart or form not rendered yet: no-op, retry on a later cart mutation */
  }
  function ensureApplied() {
    return getCart().then(function(cart) { tryAutoApply(cart); });
  }
  /* Safari caches product HTML (ETag page_cache) and /cart.js responses, so a
     page can render the drawer from a pre-add state. RESTORE-ONLY reconcile:
     two fresh no-store reads must agree the server has MORE items than shown,
     and the freshly fetched section must render at least as many rows as the
     current drawer - never tear down a populated drawer on a stale read. */
  function reconcileCartUI() {
    getCart().then(function(cart) {
      if (!cart) return;
      var comp = document.querySelector("cart-drawer-component");
      if (!comp) return;
      if (comp.querySelector("dialog[open]")) return;
      var rows = comp.querySelectorAll(".cart-items__table-row[data-key]").length;
      if (cart.items.length <= rows) return;
      getCart().then(function(cart2) {
        if (!cart2 || cart2.items.length <= rows) return;
        var section = comp.closest(".shopify-section");
        var sid = section && section.id ? section.id.replace("shopify-section-", "") : null;
        if (!sid) return;
        fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sid) + "&_lb=" + Date.now(), { credentials: "same-origin", cache: "no-store" })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var fresh = doc.querySelector("cart-drawer-component");
            var cur = document.querySelector("cart-drawer-component");
            if (!fresh || !cur || cur.querySelector("dialog[open]")) return;
            var freshRows = fresh.querySelectorAll(".cart-items__table-row[data-key]").length;
            var curRows = cur.querySelectorAll(".cart-items__table-row[data-key]").length;
            if (freshRows >= curRows && freshRows > 0) cur.replaceWith(fresh);
          })
          .catch(function() {});
      });
    });
  }
  window.addEventListener("pageshow", function(e) { if (e.persisted) reconcileCartUI(); });
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* remove our injected discount decorations when the code is no longer applied */
  function cleanupCartDecor() {
    var pbs = document.querySelectorAll(".lb-s26-priceblock");
    for (var i = 0; i < pbs.length; i++) {
      var wrap = pbs[i].parentElement;
      if (wrap) {
        var kids = wrap.children;
        for (var k = 0; k < kids.length; k++) {
          if (kids[k] !== pbs[i] && kids[k].tagName === "DIV") kids[k].style.display = "";
        }
      }
      if (pbs[i].parentNode) pbs[i].parentNode.removeChild(pbs[i]);
    }
    var hints = document.querySelectorAll(".lb-s26-saving");
    for (var j = 0; j < hints.length; j++) {
      if (hints[j].parentNode) hints[j].parentNode.removeChild(hints[j]);
    }
  }

  /* === CART DRAWER DECORATION === */
  function decorateCart() {
    getCart().then(function(cart) {
      var app = findApp(cart);
      /* chi ghi '1' khi THAY code; khong ghi '0' — gio rong thi cart.js khong co discount application (chua ap len
         mon nao) nen '0' se tat instantCart sai (do 17/09: ss='0' ngay tren PDP gio trong -> van giat). */
      try { if (app) sessionStorage.setItem('lb:s26', '1'); } catch (e) {}
      /* v2: code chua ap (dang tu ap) -> GIU gia giam da ve lac quan; chi xoa khi khach go code / het sale / ap that bai 3 lan */
      /* v2.1: chot chan - chua xac nhan code qua 5 s (code bi tat som / code khac khong cong don / khong co form) -> tra gia goc */
      if (!app) {
        var hasRows = cart && cart.items && cart.items.length > 0;
        if (hasRows && !window.__lbS26MissSince) { window.__lbS26MissSince = Date.now(); setTimeout(decorateCart, 5200); }
        var stale = window.__lbS26MissSince && (Date.now() - window.__lbS26MissSince >= 5000);
        if (userRemoved() || !saleActive() || autoTries >= 3 || stale) { window.__lbS26Stale = !!stale; cleanupCartDecor(); }
        tryAutoApply(cart); return;
      }
      window.__lbS26MissSince = 0; window.__lbS26Stale = false;
      var rate = getRate(app);
      if (rate <= 0) return;

      var itemMap = {};
      for (var i = 0; i < cart.items.length; i++) itemMap[cart.items[i].key] = cart.items[i];

      /* per-code amounts -> window.__lbDiscAmts (lb-drawer-suggester ve chip pill tu map nay) */
      (function buildAmts() {
        var sEl = document.querySelector('tr.cart-items__table-row[data-key] .cart-items__price, tr.cart-items__table-row[data-key] .cart-items__price-wrapper');
        var sample = sEl ? extractMoney(sEl.textContent.trim()) : null;
        var amts = {};
        var lvl = cart.cart_level_discount_applications || [];
        var phanBo = 0;   /* phan ma mua da tron vao gia Holiday Set -> khong tinh vao chip */
        for (var ib = 0; ib < cart.items.length; ib++) { var ii = cart.items[ib]; if (ii.properties && ii.properties._lb_set_bag) phanBo += Math.round((Number(ii.original_line_price) || 0) * rate); }
        for (var a = 0; a < lvl.length; a++) {
          var t1 = (lvl[a].title || lvl[a].code || '').toString().toUpperCase();
          var tru = (t1 === CODE || OLD_CODES.indexOf(t1) >= 0) ? phanBo : 0;
          amts[t1] = (amts[t1] || 0) + Math.max(0, (lvl[a].total_allocated_amount || 0) - tru);
        }
        for (var b = 0; b < cart.items.length; b++) {
          var alls = cart.items[b].line_level_discount_allocations || [];
          for (var c = 0; c < alls.length; c++) {
            var t2 = ((alls[c].discount_application || {}).title || '').toString().toUpperCase();
            amts[t2] = (amts[t2] || 0) + (alls[c].amount || 0);
          }
        }
        var out = {};
        for (var k in amts) {
          if (!amts[k]) continue;
          var f = sample ? renderLike(sample, amts[k]) : money(amts[k]);
          if (f) out[k] = '-' + f;
        }
        window.__lbDiscAmts = out;
      })();

      /* Subtotal gach: theme dua "original total" = SAU ma product-class (135.85) -> lech voi 142.99 o dong san pham.
         Tinh tong original_line_price (truoc MOI ma) cho lb-drawer-suggester dung. */
      (function tongGoc() {
        try {
          var sEl = document.querySelector('tr.cart-items__table-row[data-key] .cart-items__price, tr.cart-items__table-row[data-key] .cart-items__price-wrapper');
          var sample = sEl ? extractMoney(sEl.textContent.trim()) : null;
          var tong = 0, chiBo = true;
          for (var i2 = 0; i2 < cart.items.length; i2++) {
            var it2 = cart.items[i2], laBo = !!(it2.properties && it2.properties._lb_set_bag);
            if (!laBo) chiBo = false;
            tong += laBo ? Math.round((Number(it2.original_line_price) || 0) * (1 - rate)) : (Number(it2.original_line_price) || 0);
          }
          /* gio chi co Holiday Set: khong gach tong (gia bo la gia that, khong co gia goc x2) */
          window.__lbOrigTotalText = sample && tong && !chiBo ? renderLike(sample, tong) : '';
        } catch (e) { window.__lbOrigTotalText = ''; }
      })();
      var rows = document.querySelectorAll('tr.cart-items__table-row[data-key]');
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        if (row.hasAttribute('data-lb-set')) continue;   /* 01/11 Holiday Set: dong bo tu ve gia (cart-products.liquid), khong "saving with ma mua" */
        var key = row.getAttribute('data-key');
        var item = itemMap[key];
        if (!item) continue;
        var priceWrap = row.querySelector('.cart-items__unit-price-wrapper');
        /* FIX qty-bug: nguon so = LINE TOTAL cua theme (da nhan qty, dung format currency),
           va CAP NHAT gia tri moi lan chay — truoc kia ve 1 lan gia unit roi skip vinh vien
           nen doi so luong gia dung im. */
        var ltEl = row.querySelector('.cart-items__price, .cart-items__price-wrapper, [class*="line-price"]');
        var lineText = ltEl ? extractMoney(ltEl.textContent.trim()) : null;
        var unitInner = priceWrap ? priceWrap.querySelector('div:not(.lb-s26-priceblock)') : null;
        if (!lineText && unitInner) lineText = extractMoney(unitInner.textContent.trim());
        /* code product-class (vd WELCOME10) da tru san vao line price cua theme:
           'was' phai la gia goc that, 'new' = final sau ca code order-level */
        var wasText = lineText, lineHalf = null;
        if (lineText && item.original_line_price != null && item.final_line_price != null) {
          var ow = renderLike(lineText, item.original_line_price);
          if (ow) wasText = ow;
          lineHalf = renderLike(lineText, Math.round(item.final_line_price * (1 - rate)));
          if (ltEl && ow) {
            var curTop = extractMoney(ltEl.textContent.trim());
            if (curTop && curTop !== ow) ltEl.textContent = ow;
          }
        }
        if (!lineHalf) lineHalf = lineText ? makeHalf(lineText) : null;
        /* Tiet kiem = gia goc - gia cuoi (gom ca WELCOME10 lan HALLOWEEN26). Truoc day chi tinh HALLOWEEN26 va con so
           trung khit gia phai tra (50%) -> "$67.93" hien 3 lan voi 3 nghia (user thay 18/09). */
        var savingText = null, codesText = (window.__lbS26Code || CODE);
        if (lineText && item.original_line_price != null && item.final_line_price != null) {
          var cuoi = Math.round(item.final_line_price * (1 - rate));
          savingText = renderLike(lineText, Math.max(0, item.original_line_price - cuoi));
          var them = [];
          (item.line_level_discount_allocations || []).forEach(function (al) {
            var t = ((al.discount_application || {}).title || '').toString().toUpperCase();
            if (t && t !== CODE && OLD_CODES.indexOf(t) < 0 && them.indexOf(t) < 0) them.push(t);
          });
          if (them.length) codesText = (window.__lbS26Code || CODE) + ' + ' + them.join(' + ');
        }
        if (!savingText) savingText = lineHalf;
        if (priceWrap && lineHalf) {
          if (unitInner) unitInner.style.display = 'none';
          var pb = priceWrap.querySelector('.lb-s26-priceblock');
          if (!pb) {
            pb = document.createElement('div');
            pb.className = 'lb-s26-priceblock';
            pb.innerHTML = '<span class="lb-s26-new"></span><s class="lb-s26-was"></s>';
            priceWrap.appendChild(pb);
          }
          var nEl = pb.querySelector('.lb-s26-new'), wEl = pb.querySelector('.lb-s26-was');
          if (nEl && nEl.textContent !== lineHalf) nEl.textContent = lineHalf;
          if (wEl && wEl.textContent !== wasText) wEl.textContent = wasText;
        }

        /* saving hint: tao 1 lan, cap nhat SO moi lan chay */
        var qtyCell = row.querySelector("td.cart-items__quantity") || row.querySelector(".cart-items__quantity");
        var hintStrong = row.querySelector(".lb-s26-saving strong");
        var hintCodes = row.querySelector(".lb-s26-saving .lb-s26-codes");
        if (lineHalf && hintStrong) {
          if (hintStrong.textContent !== savingText) hintStrong.textContent = savingText;
          if (hintCodes && hintCodes.textContent !== codesText) hintCodes.textContent = codesText;
        } else if (lineHalf && qtyCell && !row.querySelector(".lb-s26-saving")) {
          var savingEl = document.createElement("div");
          savingEl.className = "lb-s26-saving lb-s26-saving--qty";
          savingEl.innerHTML =
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
            + " You're saving <strong>" + savingText + "</strong> with <span class=\"lb-s26-codes\">" + codesText + "</span>";
          var controls = qtyCell.querySelector(".cart-items__quantity-controls");
          if (controls && controls.nextSibling) qtyCell.insertBefore(savingEl, controls.nextSibling);
          else qtyCell.appendChild(savingEl);
        }
      }
    });
  }

  /* === INSTANT PASS (17/09) ===
     decorateCart() chi ve gia giam SAU khi fetch /cart.js -> drawer hien GIA GOC trong luc cho mang
     (260 ms may nhanh, 1-2 s mang cham) roi "giat" sang gia giam (user thay tren .co). Ham nay chay DONG BO
     ngay trong MutationObserver (truoc khi trinh duyet ve khung hinh): dung makeHalf() tren text co san
     trong drawer de dung san khoi gia + dong "You're saving" y het decorateCart(); decorateCart() ve sau
     chi CAP NHAT so (khong tao lai) nen khong nhay them lan nua. Chi chay khi biet chac code dang ap:
     lan truoc cart.js da thay (sessionStorage) hoac cookie discount_code cua Shopify = HALLOWEEN26. */
  /* LB-S26-INSTANT v2 + v2.1 (24/09): sale con chay khong (HALLOWEEN26 het han 31/10 23:59 ET = 04:00Z 01/11) */
  function saleActive() { return Date.now() < Date.parse('2026-12-01T05:00:00Z'); } /* NOVEMBER26: het 30/11 23:59 ET */
  /* nhan tien voi he so, GIU dinh dang (giong makeHalf) - dung cho gia gach = compare-at x so luong */
  function scaleMoney(text, f) {
    var m = text.match(/([^\d\s]*)\s*(\d[\d.,\s]*\d|\d)\s*([^\d\s]*)/);
    if (!m) return null;
    var pre = m[1] || '', num = m[2].split(' ').join(''), suf = m[3] || '';
    var dec = 0, decSep = '';
    var lastSep = Math.max(num.lastIndexOf('.'), num.lastIndexOf(','));
    if (lastSep > -1) { var tail = num.length - lastSep - 1; if (tail === 1 || tail === 2) { dec = tail; decSep = num[lastSep]; } }
    var minor = parseInt(num.split('.').join('').split(',').join(''), 10);
    if (isNaN(minor)) return null;
    var v = Math.round(minor * f), thouSep = '';
    var seps = num.replace(/[0-9]/g, '');
    for (var i = 0; i < seps.length; i++) { if (seps[i] !== decSep || !dec) { thouSep = seps[i]; break; } }
    var st = String(v), frac = '';
    if (dec) { while (st.length <= dec) st = '0' + st; frac = decSep + st.slice(-dec); st = st.slice(0, -dec); }
    if (thouSep) st = st.replace(/(?=(?:[0-9]{3})+$)(?!^)/g, thouSep);
    return pre + st + frac + suf;
  }
  function s26Expected() {
    if (userRemoved()) return false;
    /* v2: HALLOWEEN26 LUON duoc tu ap (va cong don duoc voi code ca nhan product-class) -> trong thoi gian sale cu ve gia giam ngay */
    if (saleActive() && !window.__lbS26Stale) return true;
    try { if (sessionStorage.getItem('lb:s26') === '1') return true; } catch (e) {}
    /* KHONG dung regex co backslash: Shopify minify asset lam '\s' thanh 's' -> '(^|;s*)' khong khop '; discount_code'
       (do that 17/09: re2=false). Tach chuoi bang split, khong escape gi ca. */
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) if (parts[i].trim().toUpperCase() === 'DISCOUNT_CODE=' + CODE || parts[i].trim().toUpperCase() === 'DISCOUNT_CODE=HALLOWEEN26') return true;
    return false;
  }
  function instantCart() {
    if (!s26Expected()) return;
    var rows = document.querySelectorAll('tr.cart-items__table-row[data-key]');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      if (row.hasAttribute('data-lb-set')) continue;   /* Holiday Set */
      if (row.querySelector('.lb-s26-priceblock')) continue;
      var priceWrap = row.querySelector('.cart-items__unit-price-wrapper');
      var ltEl = row.querySelector('.cart-items__price, .cart-items__price-wrapper, [class*="line-price"]');
      var lineText = ltEl ? extractMoney(ltEl.textContent.trim()) : null;
      var unitInner = priceWrap ? priceWrap.querySelector('div:not(.lb-s26-priceblock)') : null;
      if (!lineText && unitInner) lineText = extractMoney(unitInner.textContent.trim());
      var half = lineText ? makeHalf(lineText) : null;
      if (!priceWrap || !half) continue;
      /* v2: co code product-class (WELCOME10...) thi line price da bi tru -> gach phai la gia goc that (compare-at x so luong) */
      var wasShow = lineText;
      var cmpEl = unitInner ? unitInner.querySelector('s.compare-at-price, .compare-at-price') : null;
      var cmpText = cmpEl ? extractMoney(cmpEl.textContent.trim()) : null;
      if (cmpText) {
        var qEl = row.querySelector('input[name="updates[]"], input.quantity__input, input[type="number"]');
        var qn = qEl ? parseInt(qEl.value, 10) : 1;
        var ws = scaleMoney(cmpText, (qn && qn > 0) ? qn : 1);
        if (ws) wasShow = ws;
      }
      if (unitInner) unitInner.style.display = 'none';
      var pb = document.createElement('div');
      pb.className = 'lb-s26-priceblock';
      pb.innerHTML = '<span class="lb-s26-new"></span><s class="lb-s26-was"></s>';
      pb.querySelector('.lb-s26-new').textContent = half;
      pb.querySelector('.lb-s26-was').textContent = wasShow;
      priceWrap.appendChild(pb);
      var qtyCell = row.querySelector("td.cart-items__quantity") || row.querySelector(".cart-items__quantity");
      if (qtyCell && !row.querySelector(".lb-s26-saving")) {
        var savingEl = document.createElement("div");
        savingEl.className = "lb-s26-saving lb-s26-saving--qty";
        savingEl.innerHTML =
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
          + " You're saving <strong>" + half + "</strong> with <span class=\"lb-s26-codes\">" + (window.__lbS26Code || CODE) + "</span>";
        var controls = qtyCell.querySelector(".cart-items__quantity-controls");
        if (controls && controls.nextSibling) qtyCell.insertBefore(savingEl, controls.nextSibling);
        else qtyCell.appendChild(savingEl);
      }
    }
  }

  /* === PRODUCT CARD DECORATION === */
  function parsePrice(text) {
    var m = text.match(/(\d{1,3}(?:[,\d]{0,})\.?\d{0,2})/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/,/g, ''));
    if (isNaN(n)) return null;
    return Math.round(n * 100);  // return cents
  }

  function decorateCards() {
    var cards = document.querySelectorAll('product-card');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      if (card.querySelector('.lb-s26-card')) continue;

      /* Find the visible price container (.price__regular or .price__sale that's NOT hidden) */
      var visiblePrice = card.querySelector('.price__regular:not(.price__hidden), .price__sale:not(.price__hidden)');
      if (!visiblePrice) continue;

      /* Halve the rendered price, keeping its exact currency format */
      var priceText = visiblePrice.textContent.trim();
      var newText = makeHalf(priceText);
      if (!newText) continue;

      var wrap = document.createElement('div');
      wrap.className = 'lb-s26-card';
      wrap.innerHTML =
        '<div class="lb-s26-card__prices">'
        + '<span class="lb-s26-card__new">' + newText + '</span>'
        + '<s class="lb-s26-card__was">' + priceText + '</s>'
        + '</div>'
        + '<div class="lb-s26-card__code">with code <strong>' + CODE + '</strong></div>';

      /* Hide original visible price, insert our overlay */
      visiblePrice.style.display = 'none';
      visiblePrice.parentNode.insertBefore(wrap, visiblePrice);
    }
  }

  /* === PREDICTIVE SEARCH SUGGEST (resource-card, khong phai product-card) === */
  function decorateSearchCards() {
    var cards = document.querySelectorAll('.resource-card');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      if (card.querySelector('.lb-s26-card')) continue;
      var visiblePrice = card.querySelector('.price__regular:not(.price__hidden), .price__sale:not(.price__hidden)');
      if (!visiblePrice) continue; /* ket qua khong phai san pham (collection/page) */
      var priceText = visiblePrice.textContent.trim();
      var newText = makeHalf(priceText);
      if (!newText) continue;
      var wrap = document.createElement('div');
      wrap.className = 'lb-s26-card';
      wrap.innerHTML =
        '<div class="lb-s26-card__prices">'
        + '<span class="lb-s26-card__new">' + newText + '</span>'
        + '<s class="lb-s26-card__was">' + priceText + '</s>'
        + '</div>'
        + '<div class="lb-s26-card__code">with code <strong>' + CODE + '</strong></div>';
      visiblePrice.style.display = 'none';
      visiblePrice.parentNode.insertBefore(wrap, visiblePrice);
    }
  }


  /* === HOMEPAGE CUSTOM CAROUSEL CARDS (.lb-poe-card etc.) === */
  function decorateCustomCards() {
    /* Selector covers all hand-written homepage card prices */
    var prices = document.querySelectorAll('.lb-poe-card__price:not([data-lb-s26-done]), .lb-os__card-price:not([data-lb-s26-done]), .lb-product-card__price:not([data-lb-s26-done])');
    for (var i = 0; i < prices.length; i++) {
      var priceEl = prices[i];
      priceEl.setAttribute('data-lb-s26-done', '1');
      var srcText = priceEl.textContent.trim();
      var newText = makeHalf(srcText);
      if (!newText) continue;

      var wrap = document.createElement('div');
      wrap.className = 'lb-s26-card';
      wrap.innerHTML =
        '<div class="lb-s26-card__prices">'
        + '<span class="lb-s26-card__new">' + newText + '</span>'
        + '<s class="lb-s26-card__was">' + srcText + '</s>'
        + '</div>'
        + '<div class="lb-s26-card__code">with code <strong>' + CODE + '</strong></div>';

      priceEl.style.display = 'none';
      priceEl.parentNode.insertBefore(wrap, priceEl);
    }
  }

  var debounceTimer = null;
  var observer = new MutationObserver(function(muts) {
    var relevant = false;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType === 3) t = t.parentElement;
      if (t && t.closest && t.closest(".lb-count")) continue; /* 1s countdown tick - irrelevant */
      relevant = true; break;
    }
    if (!relevant) return;
    instantCart();   /* dong bo, truoc khi ve khung hinh -> khong "giat" gia goc */
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { decorateCart(); decorateCards(); decorateSearchCards(); decorateCustomCards(); }, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });


/* Legacy-cookie cleaner: litborne.com previously served a different Shopify
     store; returning browsers can carry TWO "cart" cookies (host-only new +
     domain-scoped legacy). The server may resolve the stale one -> checkout
     bounces home with an emptied cart. Only acts when a duplicate exists. */
  (function() {
    try {
      var cartCookies = document.cookie.split("; ").filter(function(c) { return c.indexOf("cart=") === 0; });
      if (cartCookies.length > 1) {
        var host = window.location.hostname;
        var bare = host.replace(/^www\./, "");
        document.cookie = "cart=; Max-Age=0; path=/; domain=." + bare;
        document.cookie = "cart=; Max-Age=0; path=/; domain=" + bare;
        console.warn("[lb] duplicate cart cookies detected - legacy domain-scoped copy expired");
      }
    } catch (e) {}
  })();

  /* Checkout qty guard: a cleared/zero quantity input posted with the checkout
     submit wipes that line server-side (POST /cart updates[]=0|blank) and can
     bounce the buyer home with an emptied cart. Sanitize at submit time. */
  window.addEventListener("submit", function(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.action || "";
    if (!/\/cart(\?|$)/.test(action)) return;
    var qtys = form.querySelectorAll('input[name="updates[]"]');
    for (var i = 0; i < qtys.length; i++) {
      var v = parseInt(qtys[i].value, 10);
      if (!v || v < 1) {
        var dv = parseInt(qtys[i].defaultValue, 10);
        qtys[i].value = (dv && dv > 0) ? dv : 1;
      }
    }
  }, { capture: true });

  /* === LB-S26-PREAPPLY v1 (24/09) ===
     Lan add-to-cart DAU TIEN cua phien: code chua ap (gio rong) + chua co dau hieu -> instantCart dung yen -> drawer hien
     GIA GOC ~1-1.5 s (4G, iPhone Safari mat sessionStorage moi tab) roi moi nhay sang gia giam. Ap code NGAM ngay khi vao trang:
     Shopify dat cookie discount_code + gan code vao gio -> server tra drawer da giam, instantCart co dau hieu.
     Khong de len code khac cua khach; khong chay neu khach da go code; tu tat sau 31/10 23:59 ET (04:00Z 01/11). */
  function preApply() {
    try {
      if (!saleActive()) return;
      if (userRemoved()) return;
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].trim();
        if (kv.toLowerCase().indexOf('discount_code=') === 0) return; /* da co code (HALLOWEEN26 hoac code rieng cua khach) -> khong dung vao */
      }
      if (sessionStorage.getItem('lb:s26pre') === '1') return;
      sessionStorage.setItem('lb:s26pre', '1');
      fetch('/discount/' + CODE + '?redirect=%2Fcart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (findApp(c)) { try { sessionStorage.setItem('lb:s26', '1'); } catch (e) {} } })
        .catch(function () {});
    } catch (e) {}
  }
  /* === LB-NOV26-SWAP v1 (01/11) === gio con ma mua cu (HALLOWEEN26) -> thay bang CODE, giu nguyen code rieng cua khach,
     dat lai cookie discount_code, roi ve lai drawer (dang dong) / tai lai trang /cart. Chay 1 lan moi trang. */
  function redrawDrawer() {
    var comp = document.querySelector('cart-drawer-component');
    if (!comp) return;
    var section = comp.closest('.shopify-section');
    var sid = section && section.id ? section.id.replace('shopify-section-', '') : null;
    if (!sid) return;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid) + '&_lb=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer-component');
        var cur = document.querySelector('cart-drawer-component');
        if (!fresh || !cur || cur.querySelector('dialog[open]')) return;
        cur.replaceWith(fresh);
        setTimeout(function () { instantCart(); decorateCart(); }, 50);
      })
      .catch(function () {});
  }
  function swapOld() {
    if (!saleActive() || userRemoved()) return;
    getCart().then(function (cart) {
      if (!cart) return;
      var dc = (cart.discount_codes || []).map(function (d) { return String(d.code || ''); });
      var coCu = dc.some(function (c) { return OLD_CODES.indexOf(c.toUpperCase()) >= 0; });
      if (!coCu || dc.some(function (c) { return c.toUpperCase() === CODE; })) return;
      var giu = dc.filter(function (c) { return OLD_CODES.indexOf(c.toUpperCase()) < 0; });
      giu.push(CODE);
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: giu.join(',') }) })
        .then(function () { return fetch('/discount/' + CODE + '?redirect=%2Fcart.js', { credentials: 'same-origin', cache: 'no-store' }); })
        .then(function () {
          window.__lbS26Code = null;
          try { sessionStorage.setItem('lb:s26', '1'); } catch (e) {}
          if (window.location.pathname === '/cart') {
            try { if (sessionStorage.getItem('lb:s26swap') === '1') return; sessionStorage.setItem('lb:s26swap', '1'); } catch (e) { return; }
            window.location.reload();
          } else redrawDrawer();
        })
        .catch(function () {});
    });
  }
  window.__lbS26 = { instantCart: instantCart, s26Expected: s26Expected, userRemoved: userRemoved };   /* de kiem tu console */
  function init() {
    swapOld();
    preApply();
    ensureApplied();
    reconcileCartUI();
    setTimeout(reconcileCartUI, 2500);
    instantCart();
    decorateCart();
    decorateCards();
    decorateSearchCards();
    decorateCustomCards();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
